import React from 'react'

import Phenom_icon1 from "../../../../assets/case_study/phenomIcon1.png"
import Phenom_icon2 from "../../../../assets/case_study/phenomIcon2.png"
import Phenom_icon3 from "../../../../assets/case_study/phenomIcon3.png"
import Phenom_icon4 from "../../../../assets/case_study/phenomIcon4.png"
import Phenom_icon5 from "../../../../assets/case_study/phenomIcon5.png"

import monitra_icon1 from "../../../../assets/case_study/incuSpaze1.png"
import monitra_icon2 from "../../../../assets/case_study/monitra_icon2_section1.png"
import monitra_icon3 from "../../../../assets/case_study/incuSpaze3.png"
import monitra_icon4 from "../../../../assets/case_study/monitra_icon4_section1.png"
import monitra_icon5 from "../../../../assets/case_study/incuSpaze4.png"

import incuspaze_icon2 from "../../../../assets/case_study/incuSpaze2.png"
import incuspaze_icon5 from "../../../../assets/case_study/incuSpaze5.png"

import ikf_icon1 from "../../../../assets/case_study/ifk_finance1.png"
import ikf_icon2 from "../../../../assets/case_study/ifk_finance2.png"
import ikf_icon3 from "../../../../assets/case_study/ifk_finance3.png"


import goken_icon2 from "../../../../assets/case_study/goken2.png"
import goken_icon3 from "../../../../assets/case_study/goken3.png"
import goken_icon4 from "../../../../assets/case_study/goken4.png"
import goken_icon5 from "../../../../assets/case_study/goken5.png"



import { useParams } from 'react-router-dom'

const CaseStudySection2 = {
  phenom: {
    Icons1: Phenom_icon1,
    Icons2: Phenom_icon2,
    Icons3: Phenom_icon3,
    Icons4: Phenom_icon4,
    Icons5: Phenom_icon5,
    paragrphcontent: "Prior to engaging with Hirestar.io, Phenom’s background verification process faced multiple friction points:",
    content1: "Slow, manual workflows delayed onboarding and created operational drag.",
    content2: "HR Involvement in Background Verification Workflows: Phenom’s Recruiters were constantly involved, chasing updates from candidates and BGV vendors.",
    content3: "Disorganized BGV reports: Reports were inconsistent, difficult to interpret, and often lacked clarity.",
    content4: "Lack of automation: No integrations with internal HR systems meant double work and reduced efficiency.",
    content5: "AI-centric expectations: As a cutting-edge AI company, Phenom sought intelligent document verification and fraud detection, which legacy vendors could not provide.",
    bottom_para: "These challenges used HR bandwidth from their core functions as well provided a subpar candidate experience. "
  },
  goken:{
    Icons1: Phenom_icon1,
    Icons2: goken_icon2,
    Icons3: goken_icon3,
    Icons4: goken_icon4,
    Icons5: goken_icon5,
    paragrphcontent: "Before partnering with Hirestar.io, Goken encountered several inefficiencies and roadblocks in its background verification process:",
    content1: "Delayed Turnaround Time (TAT): The previous vendor’s TAT caused hiring delays and slowed onboarding.",
    content2: " Limited Customization: Existing BGV solutions lacked support for medical checks and couldn’t align with Goken’s internal reporting and workflow requirements.",
    content3: " Manual Dependencies: Despite working with a vendor, several verification steps required manual input and follow-ups, increasing HR workload and processing time.",
    content4: "Bulk Hiring Constraints: Goken’s large-scale hiring cycles required a platform that could efficiently handle volume without compromising speed or accuracy.",
    content5: "Fragmented Experience for Diverse Workforce: Candidates from regional and blue-collar backgrounds faced difficulty accessing English-only, complex portals.",
    bottom_para: " Additionally, Goken’s HR team had to manage separate portals for white- and blue-collar employees, leading to operational inefficiency."
  },
  ikf:{
    Icons1: ikf_icon1,
    Icons2: ikf_icon2,
    Icons3: ikf_icon3,
    Icons4: goken_icon4,
    Icons5: goken_icon5,
    paragrphcontent: "IKF Finance faced operational and compliance challenges with their existing BGV approach:",
    content1: "Manual, fragmented processes slowed down verification and increased turnaround time.",
    content2: "Limited vendor capacity made it difficult to handle multiple background checks in parallel.",
    content3: "No intelligent screening tools — lacking AI-based document forgery, face match, or social media checks.",
    content4: "Heavy HR workload — teams were burdened with constant follow-ups and coordination.",
    content5: "Restricted verification coverage — only basic checks, with no access to medical testing or blockchain-based records.",
    bottom_para: "These inefficiencies led to onboarding delays, inconsistent compliance, and unnecessary pressure on the HR team."
  },
  monitra:{
    Icons1: monitra_icon1,
    Icons2: monitra_icon2,
    Icons3: monitra_icon3,
    Icons4: monitra_icon4,
    Icons5: monitra_icon5,
    paragrphcontent: "Before Hirestar.io, Monitra’s HR and compliance teams were held back by:",
    content1: "Manual, error-prone BGV processes that delayed onboarding of medical staff.",
    content2: "Language barriers, especially with field nurses who preferred Telugu — leading to miscommunication and incomplete forms.",
    content3: "Lack of mobile access made verification difficult for remote and on-the-go staff.",
    content4: "No integrated solution for medical tests, forcing HR to manage clinical screening separately.",
    content5: "Inconsistent turnaround times and little visibility from their legacy verification partner.",
    bottom_para: "In a healthcare setting, these delays weren’t just operational — they directly impacted patient readiness and trust."
  },
  incuspaze:{
    Icons1: monitra_icon1,
    Icons2: incuspaze_icon2,
    Icons3: monitra_icon3,
    Icons4: monitra_icon5,
    Icons5: incuspaze_icon5,
    paragrphcontent: "Before engaging with Hirestar.io, Incuspaze faced several operational and security gaps in their background verification and visitor management processes:",
    content1: "Manual BGV workflows were time-consuming and error-prone, affecting onboarding speed and compliance.",
    content2: "Their previous BGV vendor lacked quality, with incomplete and poorly structured reports that created more confusion than clarity.",
    content3: "Slow support response times from their vendor led to delays and communication bottlenecks.",
    content4: "For visitors, Incuspaze used Zoho-based manual forms which offered no identity validation or real-time control.",
    content5: "They also needed advanced company-level verifications (like GST, CIN, DIN, Corporate PAN, Entity Crime Check), which weren’t available with their prior solution.",
    bottom_para: "These limitations created risk, increased operational effort, and slowed down critical onboarding and access workflows."
  },
}

export default function PhenomCaseSection2() {
     const { companyName } = useParams(); // For Getting the Route Name
        const { Icons1, Icons2, Icons3, Icons4, Icons5, content1, content2, content3, content4, content5, paragrphcontent, bottom_para } = CaseStudySection2[companyName]; // Render the content accourding to the param or company name
    return (
        <section className="  background_section2 mx-4  min-h-screen">
            {/* Desktop and Tablet View */}
            <div className="flex w-full h-full flex-col lg:flex-row mt-8">
                {/* Text Box */}
                <div className="h-full rounded-lg flex flex-col items-center justify-center text-center p-6">
                    <h3 className="text-[43.26px] font-semibold leading-relaxed text-black mb-10">
                         The Challenge
                    </h3>

                     <div className='lg:w-[75%] w-full'>
                        <p className='text-[23px] font-normal leading-relaxed text-black mb-10 text-center'>{paragrphcontent} </p>
                    </div>

                    {/* Center the grid */}
                    <div className="flex flex-wrap gap-6 justify-center">
                        {/* Card 1 */}
                        <div className="w-full sm:w-[45%] lg:w-[30%] p-4">
                            <div className="h-full rounded-lg shadow-md flex flex-col items-center justify-center p-6 text-center">
                                <img src={Icons1} alt="Icon 1" className="mb-4 w-24" />
                                <p>{content1}</p>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="w-full sm:w-[45%] lg:w-[30%] p-4">
                            <div className="h-full rounded-lg shadow-md  flex flex-col items-center justify-center p-6 text-center">
                                <img src={Icons2} alt="Icon 2" className="mb-4 w-24 h-24" />
                                <p>{content2}</p>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="w-full sm:w-[45%] lg:w-[30%] p-4">
                            <div className="h-full rounded-lg shadow-md  flex flex-col items-center justify-center p-6 text-center">
                                <img src={Icons3} alt="Icon 3" className="mb-4 w-24 h-24" />
                                <p>{content3}</p>
                            </div>
                        </div>

                        {/* Card 4 */}
                        <div className="w-full sm:w-[45%] lg:w-[30%] p-4">
                            <div className="h-full rounded-lg shadow-md  flex flex-col items-center justify-center p-6 text-center">
                                <img src={Icons4} alt="Icon 4" className="mb-4 w-24 h-24" />
                                <p>{content4}</p>
                            </div>
                        </div>

                        {/* Card 5 */}
                        <div className="w-full sm:w-[45%] lg:w-[30%] p-4">
                            <div className="h-full rounded-lg shadow-md  flex flex-col items-center justify-center p-6 text-center">
                                <img src={Icons5} alt="Icon 5" className="mb-4 w-24 h-24" />
                                <p>{content5}</p>
                            </div>
                        </div>
                    </div>

                    <div className='lg:w-[75%] w-full'>
                        <p className='text-[23px] font-normal leading-relaxed text-black mb-10 text-center mt-12'>{bottom_para} </p>
                    </div>

                </div>
            </div>
        </section>
    )
}
